<template>
  <div class="brand-slider">
    <div class="brand-slider__inner page-width">
      <div ref="container" class="page-width swiper-container">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div v-for="(brand, idx) in brands" :key="idx" class="swiper-slide">
            <a class="swiper-slide__url" :href="brand.url"></a>
            <img
              class="swiper-slide__image"
              :src="brand.image"
              :alt="brand.image_alt"
            />
          </div>
        </div>
        <div class="swiper-slide__left-shader"></div>
        <div class="swiper-slide__right-shader"></div>
        <!-- If we need navigation buttons -->
      </div>
      <div ref="prev" class="swiper-button-prev"></div>
      <div ref="next" class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation } from "swiper/core";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation]);

export default {
  selector: "#vue-brand-slider",
  props: {
    brands: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.container, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.brand-slider {
  --swiper-theme-color: #b6b6b6;
  --swiper-navigation-size: 18px;
  background-color: #fff;
  padding: 32px 0;
  &__inner {
    position: relative;
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
.swiper-slide {
  width: 100px;
  height: 100px;
  padding: 5px;
  display: flex;
  &__image {
    margin: auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  &__url {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  &__right-shader,
  &__left-shader {
    pointer-events: none;
    position: absolute;
    width: 50px;
    height: 100%;
    top: 0;
    z-index: 10;
  }
  &__right-shader {
    right: 0;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.75) 30%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  &__left-shader {
    left: 0;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.75) 30%,
      rgba(255, 255, 255, 1) 100%
    );
  }
}
</style>
